import { Provider } from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

/**
 * Every tooltip gets the app tooltip look (`.white-tooltip` in styles.scss: the sitenotes-ds dark `tooltip`, DESIGN.md
 * "Tooltips"; the class keeps its historical name). The delays are Material's own defaults. A `matTooltipClass` set on a tooltip replaces this class, so a tooltip with
 * its own class adds `white-tooltip` to it.
 */
export const APP_TOOLTIP_DEFAULTS: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  tooltipClass: 'white-tooltip',
};

export const APP_TOOLTIP_PROVIDER: Provider = { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: APP_TOOLTIP_DEFAULTS };
